export default __webpack_public_path__ + "static/certificate-toddler-vertical-2b4ea4d966b0a352452a0c4f8220c7d5.png";